"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
require("./index.scss");
const clsx_1 = __importDefault(require("clsx"));
const uuid_1 = require("uuid");
const MlcTooltip_1 = __importDefault(require("@Components/MlcTooltip"));
const CustomToolTip = ({ title, info, type, inverse, place }) => {
    const toolTipId = (0, uuid_1.v4)();
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("span", { className: (0, clsx_1.default)('custom-tool-tip', inverse && 'inverse') }, type ? (react_1.default.createElement("span", { className: `info-label` },
            react_1.default.createElement("span", { "data-tooltip-id": toolTipId }, type))) : (react_1.default.createElement("p", { "data-tooltip-id": toolTipId }, title))),
        react_1.default.createElement(MlcTooltip_1.default, { id: toolTipId, variant: 'info', place: place !== null && place !== void 0 ? place : 'bottom', className: "custom-tool-tip-content" },
            react_1.default.createElement("span", null, info))));
};
exports.default = CustomToolTip;
